/**
 * UC-43: PlayAudio — SFX and ambient via IAudioPort.
 */
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IAudioPort, SoundType } from '../../domain/ports/IAudioPort';

export type AudioAction =
  | { type: 'sfx'; sound: SoundType }
  | { type: 'start_ambient' }
  | { type: 'stop_ambient' }
  | { type: 'init' }
  | { type: 'set_volumes'; master: number; sfx: number; ambient: number };

export interface PlayAudioInput {
  action: AudioAction;
}

export interface PlayAudioOutput {
  ok: boolean;
}

export interface PlayAudioDependencies {
  audio: IAudioPort;
  logger?: IAppLogger;
}

export class PlayAudioUseCase {
  constructor(private readonly deps: PlayAudioDependencies) {}

  execute(input: PlayAudioInput): PlayAudioOutput {
    const { action } = input;

    switch (action.type) {
      case 'sfx':
        this.deps.audio.playSfx(action.sound);
        break;
      case 'start_ambient':
        this.deps.audio.startAmbientNoise();
        break;
      case 'stop_ambient':
        this.deps.audio.stopAmbientNoise();
        break;
      case 'init':
        this.deps.audio.initAudio();
        break;
      case 'set_volumes':
        this.deps.audio.setVolumes(action.master, action.sfx, action.ambient);
        break;
      default:
        return { ok: false };
    }

    this.deps.logger?.log('debug', 'audio.action', { type: action.type });
    return { ok: true };
  }
}